module.exports = new __parcel__URL__("frog.566a6fa2.svg").toString();